export const ButtonLabels = {
  Ok: 'Ok',
  Both: 'Both',
  OutcomeOnly: 'Outcome only',
  Move: 'Move'
};
